export default __webpack_public_path__ + "static/99b977a1-b764-4eb9-ae07-76a78672eb9e-b82aebb26e9634efbb3162712a0b1b77.woff";